import React from "react";

const SharesSubdivision = () => {
  return <div>SharesSubdivision</div>;
};

export default SharesSubdivision;
